import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mode-card",
  "use": "mode-card-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"mode-card\"><path d=\"M6 9c.6 0 1 .4 1 1v3c0 1.1-.9 2-2 2H2c-.6 0-1-.4-1-1v-3c0-1.1.9-2 2-2h3zm7 0c1.1 0 2 .9 2 2v3c0 .6-.4 1-1 1h-3c-1.1 0-2-.9-2-2v-3c0-.6.4-1 1-1h3zm-7.3 1.3H3c-.4 0-.6.3-.7.6v2.8H5c.4 0 .6-.3.7-.6v-2.8zm7.3 0h-2.7V13c0 .4.3.6.6.7h2.8V11c0-.4-.3-.6-.7-.7zM5 1c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V2c0-.6.4-1 1-1h3zm9 0c.6 0 1 .4 1 1v3c0 1.1-.9 2-2 2h-3c-.6 0-1-.4-1-1V3c0-1.1.9-2 2-2h3zM5 2.3H2.3V5c0 .4.3.6.6.7H5c.4 0 .6-.3.7-.6V3c0-.4-.3-.6-.7-.7zm8.7 0H11c-.4 0-.6.3-.7.6v2.8H13c.4 0 .6-.3.7-.6V2.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/mode-card.svg
// module id = DM7C
// module chunks = 6